import { motion } from "framer-motion";
import { fadeUp, stagger, viewportOnce } from "@/lib/motion";
import { FileText, Download, Check } from "lucide-react";

const INCLUDES = [
  "The 4 must-know credentials (NPI · NPPES · CAQH · OIG)",
  "All 3 payer pathways compared side-by-side",
  "Documentation checklist from intake to billing",
  "The 7-step launch roadmap",
];

export const LeadMagnet = ({ onDownload }) => (
  <section data-testid="lead-magnet-section" className="relative overflow-hidden bg-ink py-16 md:py-28">
    <div className="absolute inset-0 spotlight" aria-hidden="true" />
    <div className="container-tasha relative">
      <motion.div
        variants={stagger}
        initial="hidden"
        whileInView="visible"
        viewport={viewportOnce}
        className="card-luxe grid items-center gap-10 border-gold/25 p-8 md:grid-cols-[1.4fr_1fr] md:p-12"
      >
        <div>
          <motion.span variants={fadeUp} className="overline flex items-center gap-2">
            <FileText size={15} /> Free Download
          </motion.span>
          <motion.h2 variants={fadeUp} className="mt-5 font-serif text-4xl font-semibold leading-tight tracking-tight text-cream md:text-5xl">
            The Launch <span className="font-script text-gold">Blueprint</span>
          </motion.h2>
          <motion.p variants={fadeUp} className="mt-5 max-w-lg font-sans text-lg font-light text-cream/70">
            Grab the complete guide from our latest class — everything you need to
            understand a home health agency, no clinical background required. Drop
            your email and it's yours instantly.
          </motion.p>

          <motion.ul variants={fadeUp} className="mt-7 grid gap-2 sm:grid-cols-2">
            {INCLUDES.map((it, i) => (
              <li key={i} className="flex items-start gap-2 font-sans text-sm text-cream/75">
                <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-gold/15 text-gold">
                  <Check size={12} />
                </span>
                {it}
              </li>
            ))}
          </motion.ul>

          <motion.button
            variants={fadeUp}
            onClick={onDownload}
            data-testid="lead-magnet-cta-btn"
            className="btn-gold mt-8"
          >
            Get the Free Blueprint <Download size={16} />
          </motion.button>
        </div>

        {/* Faux PDF cover */}
        <motion.div variants={fadeUp} className="flex justify-center">
          <motion.div
            whileHover={{ rotate: 0, y: -6 }}
            initial={{ rotate: 3 }}
            className="relative aspect-[3/4] w-56 overflow-hidden rounded-lg border border-gold/30 bg-gradient-to-br from-ink-surface to-ink shadow-2xl md:w-64"
          >
            <div className="flex h-full flex-col justify-between p-6">
              <div>
                <span className="overline text-[10px]">#AskTasha</span>
                <p className="mt-3 font-serif text-2xl leading-tight text-cream">
                  The Home Care Agency
                </p>
                <p className="font-script text-3xl text-gold">Launch Blueprint</p>
              </div>
              <div className="flex items-center gap-2 text-cream/50">
                <FileText size={16} className="text-gold" />
                <span className="font-sans text-xs uppercase tracking-widest">PDF Guide</span>
              </div>
            </div>
            <div className="pointer-events-none absolute inset-0 ring-1 ring-inset ring-gold/20" />
          </motion.div>
        </motion.div>
      </motion.div>
    </div>
  </section>
);

export default LeadMagnet;
